import React from 'react';

/**
 * Displays the builds name
 * @param {string} name
 * @returns
 */
function BuildCardName({ name }) {
	return <div className="text-2xl 2k:text-3xl text-white font-bold">{name}</div>;
}

export default BuildCardName;
